/**
 * Only use this to import certain routes that we only want to be included on dev environment
 * but not on production environment for testing purposes
 */
if (process.env.NODE_ENV === "production") {
  module.exports = [];
} else {
  module.exports = require("./dev");
}
